import React, { useState, useEffect } from 'react';
import TopStatusBar from './TopStatusBar';
import NotificationBar from './NotificationBar';

interface NotificationData {
  notice_type: 'normal' | 'deviation' | 'poor_response' | 'excellent_response';
  notice_title: string;
  notice_content: string;
}

interface TopBarContainerProps {
  // TopStatusBar props
  aiIconPosition?: number;
  showFinishBtn?: boolean;
  showTimer?: boolean;
  timerText?: string;
  onFinishClick?: () => void;
  analysisReason?: string;
  showAnalysisBubble?: boolean;
  onToggleAnalysisBubble?: () => void;
  
  // 时长相关参数
  chatDuration?: number; // 当前对话时长（秒）
  minDuration?: number; // 最短练习时长（秒）
  maxDuration?: number; // 最大练习时长（秒）
  scenarioDetail?: any; // 场景详情，包含最短时长信息
  onTimeUp?: () => void;
  
  // NotificationBar props
  notification?: NotificationData;
  showNotification?: boolean;
  onNotificationClose?: () => void;
  notificationDuration?: number;
}

const TopBarContainer: React.FC<TopBarContainerProps> = ({
  // TopStatusBar props
  aiIconPosition = 40,
  showFinishBtn = true,
  showTimer = false,
  timerText = '00:00',
  onFinishClick,
  analysisReason = '',
  showAnalysisBubble = false,
  onToggleAnalysisBubble,
  
  // 时长相关参数
  chatDuration = 0,
  minDuration = 180, // 默认3分钟
  maxDuration = 0, // 默认无最大时长
  scenarioDetail,
  onTimeUp,
  
  // NotificationBar props
  notification,
  showNotification = false,
  onNotificationClose,
  notificationDuration = 5000
}) => {
  const [currentView, setCurrentView] = useState<1 | 2>(1); // 1: TopStatusBar, 2: NotificationBar
  
  // 计算是否达到最短练习时长
  const isMinDurationMet = chatDuration >= minDuration;
  
  const toggleStatus =()=> {
    console.log('toggleStatus==>',currentView);
    
    setCurrentView(currentView===2?1:2)
  }
  // 处理通知显示逻辑
  useEffect(() => {
    if (showNotification && notification) {
      setCurrentView(2);
      
      // 自动关闭通知
      if (notificationDuration > 0) {
        const timer = setTimeout(() => {
          setCurrentView(1);
          onNotificationClose?.();
        }, notificationDuration);
        
        return () => clearTimeout(timer);
      }
    } else {
      setCurrentView(1);
    }
  }, [showNotification, notification, notificationDuration, onNotificationClose]);

  const getTransform = (view: 1 | 2) => {
    if (view === currentView) {
      return 'translateX(0%) scale(1)';
    }
    if (view === 1 && currentView === 2) {
      return 'translateX(-90%) scale(1.02) ' ;
    }
    if (view === 2 && currentView === 1) {
      return 'translateX(90%) scale(.4)';
    }
    return 'translateX(0%)';
  };

  return (
    <div className="relative w-full h-36 bg-white border-b border-gray-100 overflow-hidden">
      <div onClick={toggleStatus} className='absolute left-2 top-2 z-10'>   </div>
      {/* TopStatusBar */}
      <div 
        className="absolute inset-0 transition-transform duration-300 ease-in-out"
        style={{ transform: getTransform(1) }}
      >
        <TopStatusBar
          aiIconPosition={aiIconPosition}
          showFinishBtn={showFinishBtn}
          showTimer={showTimer}
          timerText={timerText}
          onFinishClick={onFinishClick}
          analysisReason={analysisReason}
          showAnalysisBubble={showAnalysisBubble}
          onToggleAnalysisBubble={onToggleAnalysisBubble}
          chatDuration={chatDuration}
          minDuration={minDuration}
          maxDuration={maxDuration}
          isMinDurationMet={isMinDurationMet}
          onTimeUp={onTimeUp}
        />
      </div>
      
      {/* NotificationBar */}
      <div 
        className="absolute inset-0 transition-transform duration-300 ease-in-out flex items-center"
        style={{ transform: getTransform(2) }}
      >
        <NotificationBar
          notification={notification}
          visible={currentView === 2}
          onClose={() => {
            setCurrentView(1);
            onNotificationClose?.();
          }}
        />
      </div>
    </div>
  );
};

export default TopBarContainer;